/**
 * Canonical modal registry names (in-memory; not URL fragments).
 * Use these instead of string literals so typos fail at import time.
 */
export const ModalName = {
  ALOITA_TILAUS: 'aloita-tilaus',
  ADDRESS_SELECTION_FLOW: 'AddressSelectionModal',
  ACCOUNT_ADDRESS_BOOK: 'accountAddressBookModal',
  DESKTOP_ADDRESS_BOOK: 'desktopAddressBookModal',
  PAYMENT_METHODS: 'PaymentMethods',
  SPLIT_PAYMENT_METHODS: 'SplitPaymentMethods',
  GIFT_CARD_PAYMENT_METHODS: 'GiftCardPaymentMethods',
  LUNCH_DRINK: 'lunchDrink',
  LUNCH_DRINK_UPSELL: 'lounasjuoma',
  CROSS_SELL_UPSELL: 'muista-viela-nama',
  CROSS_SELL_SELECT: 'valitse-tuotteita',
  ADD_COUPON: 'addCoupon',
  LOYALTY_PRODUCT: 'loyaltyProduct',
  UPSELL_ALCOHOL: 'Alkoholit',
  ALL_COUPONS: 'all-coupons',
  LOGOUT: 'logout-modal',
  EDIT_ACCOUNT_INFO: 'edit-account-information-modal',
  DELETE_ACCOUNT: 'delete-account-modal',
  JOIN_LOYALTY: 'loyalty-modal',
  ERROR: 'error',
  PERMISSION: 'permission-modal',
  INGREDIENT_INFO: 'ingredient-info-modal',
  DELIVERY_WITHOUT_PACKAGING: 'delivery-without-packaging-modal',
  SHARE_PRODUCT: 'share-product-modal',
  PRODUCT_CLOSE: 'product-close-modal',
  HISTORIC_ORDER: 'historicOrderModal',
  UPSELL_KYYTIPOJAKSI: 'kyytipojaksi',
  PRODUCT_CATEGORY_MODAL: 'productCategoryModal',
  COUPON_SELECTOR_MODAL: 'couponSelectorModal',
} as const;

export type ModalNameValue = (typeof ModalName)[keyof typeof ModalName];

export const MODAL_QUERY_PARAM = 'modal' as const;

/** Modals that may be opened once via `?modal=` on supported entry routes */
export const deepLinkableModalValues: ReadonlySet<string> = new Set<string>([
  ModalName.ALOITA_TILAUS,
  ModalName.PAYMENT_METHODS,
  ModalName.GIFT_CARD_PAYMENT_METHODS,
  ModalName.ALL_COUPONS,
]);

export const editAddressModalName = (addressId: number): string => `editAddressModal-${addressId}`;

export const editAddressAccountPageModalName = (addressId: number): string =>
  `editAddressModal-accountPage-${addressId}`;

export const paymentConfirmModalName = (modalId: string): string =>
  `paymentConfirmModal-${modalId}`;

export const comboProductSelectionModalName = (uuid: string): string =>
  `comboProductSelection-${uuid}`;

export const productModalName = (productId: string | number): string => `productModal-${productId}`;

export const comboPageModalName = (campaignSlug: string): string => `comboPage-${campaignSlug}`;

export const categoryUpsellModalName = (categoryName: string): string =>
  encodeURIComponent(`${categoryName}Upsell`);

export const crossSellModalNameForIndex = (index: number): string =>
  index < 1 ? ModalName.CROSS_SELL_SELECT : `${ModalName.CROSS_SELL_SELECT}-${index + 1}`;
